<template>
  <div class="m-wrap m-pc">
    <Header :extras="extras"></Header>
    <Banner :extras="extras"></Banner>
    <!--<div class="logo">-->
    <!--<img src="../../assets/images/pc/logo.png" alt="" />-->
    <!--</div>-->
    <!--<div class="banner">-->
    <!--<img src="../../assets/images/pc/banner.png" alt="" />-->
    <!--</div>-->
    <SuccessCon
      :extras="extras"
      :platform="platform"
      :is-show-again="isShowAgain"
    />
    <!--<div class="content">-->
    <!--<div class="u-success">-->
    <!--<img src="../../assets/images/pc/icon-success.png" alt="" />-->
    <!--</div>-->
    <!--<div-->
    <!--class="t-success"-->
    <!--:style="{-->
    <!--color: extraItem.extras('successTitle.color'),-->
    <!--fontSize: pxOrVw(extraItem.extras('successTitle.size')),-->
    <!--fontWeight:-->
    <!--extraItem.extras('successTitle.weight') == 'default'-->
    <!--? '500'-->
    <!--: extraItem.extras('successTitle.weight'),-->
    <!--display: extraItem.extras('successTitle.display')==1?'block':'none'-->
    <!--}"-->
    <!--&gt;-->
    <!--{{ extras | extra("successTitle.model") }}-->
    <!--</div>-->
    <!--<div-->
    <!--class="t-success-desc"-->
    <!--:style="{-->
    <!--color: extraItem.extras('successText.color'),-->
    <!--fontSize: pxOrVw(extraItem.extras('successText.size')),-->
    <!--fontWeight:-->
    <!--extraItem.extras('successText.weight') == 'default'-->
    <!--? '400'-->
    <!--: extraItem.extras('successText.weight'),-->
    <!--}"-->
    <!--&gt;-->
    <!--{{ extras | extra("successText.model") }}-->
    <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
import Header from "../../../stempcore/src/core/components/common/Header.vue";
import Banner from "../../../stempcore/src/core/components/common/Banner.vue";
import SuccessCon from "@/components/SuccessCon.vue";
import mixinConfig from "../../mixin/config.js";
import mixinSuccess from "../../mixin/success.js";
export default {
  name: "PcSuccess",
  mixins: [mixinConfig, mixinSuccess],
  components: {
    Header,
    Banner,
    SuccessCon,
  },
  data() {
    return {
      platform: "pc",
      isShowAgain: false,
    };
  },
};
</script>
